import { yupResolver } from '@hookform/resolvers/yup';

import yup, { ErrorLengthMax, ErrorLengthMin } from 'utils/yup-form-validator';

const schema = yup.object({
  name: yup.string()
    .min(3, ErrorLengthMin(3)).max(48, ErrorLengthMax(48))
    .isAlphanumericHypenBracketSpace()
    .required(),
  ipMulticastAddress: yup.string()
    .when('isMulticast', {
      is: true,
      then: yup.string().required(),
    }),
});

const validator = yupResolver(schema);

export default validator;
